export const environment = {
  production: true,
  baseUrl: 'https://api.sitecreator.io/v1',
  backUrl: 'http://admin.sitecreator.io',
  lpUrl: 'http://dev.sitecreator.io',
	AIUrl: 'https://rkslxeo8jc.execute-api.us-east-1.amazonaws.com/prod/ai',
  instagramOAuthUrl: 'https://api.instagram.com/oauth',
  instagramOAuth2Url: 'https://graph.instagram.com',
  instagramAppId: '216764200291980',
  leadifulUrl: 'https://app.leadiful.io',
  leadifulKiaUrl: 'https://crm.kia-maroc.com',
  emailKia: 'kia-maroc@sitecreator.io',
  cloudFrontGalleryLinkDev: 'https://d3hct4m1dwx9vi.cloudfront.net',
  cloudFrontGalleryLinkProd: 'https://d3guxxjrkgdfh.cloudfront.net',
  blogFrontGalleryLinkDev: 'https://d27mk5n4iznzcz.cloudfront.net',
  blogFrontGalleryLinkProd: 'https://d3qkxu5epq9l6.cloudfront.net',
  ecommerceFrontGalleryLink: 'https://dpnvrnje7tpnr.cloudfront.net',
  aiFrontGalleryLink: 'https://d1drnsc542uxon.cloudfront.net',
  instagramAppSecret: 'ab0d3b0197e759bc5d1a0106a540a78e',
  CommerceUrl: 'https://abmp0wzy82.execute-api.us-east-1.amazonaws.com/prod',
  cognitoConf: {
    'serviceEndpoint': 'fgp9bdkrf9.execute-api.us-east-1.amazonaws.com',
    'cognito': {
      'cognitoPoolId': 'us-east-1_fZBosPP1s',
      'cognitoClientPoolId': '2mk3ft38rugl2rcu8gnbnf6rnt',
      'cognitoClientPoolIdShortToken': '2mk3ft38rugl2rcu8gnbnf6rnt',
      'cognitoDomain': 'https://sitecreator-production.auth.us-east-1.amazoncognito.com'
    },
    'region': 'us-east-1'
  },
  plans: {
    trial: {
      yearlyPlanId: '',
      monthlyPlanId: '',
      title: 'Trial',
      siteCredits: 1,
      monthlyPrice: 0,
      yearlyPrice: 0
    },
    starter: {
      yearlyPlanId: 'price_1HQiWKEaeqOdvz4Z1bTKbDRb',
      monthlyPlanId: 'price_1HQiWJEaeqOdvz4ZYLKFSYiA',
      title: 'Starter',
      siteCredits: 1,
      monthlyPrice: 3.99,
      yearlyPrice: 29.99
    },
    smallBusiness: {
      title: 'Small Business',
      yearlyPlanId: 'price_1HQiWxEaeqOdvz4ZgSs3wKyc',
      monthlyPlanId: 'price_1HQiWxEaeqOdvz4ZYlmwA0be',
      siteCredits: 3,
      monthlyPrice: 9.99,
      yearlyPrice: 99
    },
    enterprise: {
      title: 'Enterprise',
      yearlyPlanId: 'price_1HQiXKEaeqOdvz4ZqvFnUxPZ',
      monthlyPlanId: 'price_1HQiXKEaeqOdvz4ZwSgIiHzH',
      siteCredits: 10,
      monthlyPrice: 29.99,
      yearlyPrice: 239
    }
  },
  AIplans: {
    trial: 20,
    starter: 30,
    smallBusiness: 50,
    enterprise: 100
  }
};
